export default [
  {
    path: '/yard/:id',
    name: 'yard',
    component: () => import(/* webpackChunkName: "yard-routes" */ '@/views/Yards/components/Yard'),
    meta: { permission: 'api.view_yard' },
    reverse: 'yards-single'
  },
  {
    path: '/yard-list',
    component: () => import(/* webpackChunkName: "yard-routes" */ '@/views/Yards/YardParent'),
    children: [
      {
        path: '',
        name: 'yard-list',
        component: () => import(/* webpackChunkName: "yard-routes" */ '@/views/Yards/YardList'),
        meta: { permission: 'api.view_yard' }
      },
      {
        path: '/create-yard',
        name: 'create-yard',
        component: () => import(/* webpackChunkName: "yard-routes" */ '@/views/Yards/components/CreateYard'),
        meta: { permission: 'api.add_yard' }
      }
    ]
  }
]
